import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["option", "backgroundColor", "borderColor", "textColor", "hoverColor"]

  connect() {
    this.selectDefaultColor()
  }

  selectColor(event) {
    const option = event.currentTarget
    const colorData = option.dataset

    // Update hidden fields
    this.backgroundColorTarget.value = colorData.background
    this.borderColorTarget.value = colorData.border
    this.textColorTarget.value = colorData.text
    this.hoverColorTarget.value = colorData.hover

    // Update visual selection
    this.optionTargets.forEach(opt => opt.classList.remove('selected'))
    option.classList.add('selected')
  }

  selectDefaultColor() {
    // Select the first color by default if none is selected
    if (!this.optionTargets.some(opt => opt.classList.contains('selected'))) {
      const firstOption = this.optionTargets[0]
      if (firstOption) {
        this.selectColor({ currentTarget: firstOption })
      }
    }
  }
} 